<template>
    <div @click.stop="$parent.$parent.onEditer(index)">
      <div class="drag optional" :class="{selected:index === selectedIndex}">
        <div class="diy-option" :style="{background:item.style.background}">
          <ul class="list">
            <li class="item" :key="index" v-for="(navBar,index) in item.data">
              <div class="item-text text-ellipsis" :style="{color:navBar.color}">
                {{navBar.text}}
                </div>
            </li>
          </ul>
        </div>
        <div class="btn-edit-del">
          <div class="btn-del" @click.stop="$parent.$parent.onDeleleItem(index)">删除</div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    props: ['item', 'index', 'selectedIndex'],
    methods: {

    }
  };
</script>

<style>
.diy-option {overflow: auto;white-space: nowrap;}
.diy-option .list{ display: flex; flex-wrap: nowrap; align-items: flex-start;}
.diy-option .list .item{ padding: 10px 0; display: flex; justify-content: center; align-items: center; flex-direction: column;}
.diy-option .list .item-text{ width: 100%; padding: 4px 4px; text-align: center;}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/model/Option.vue